// App.jsx
import React, { useState, useMemo } from "react";
import "./scss/App.scss";
import Home from "./Home";
import Quiz from "./Quiz";

// A simple Thank You view
function ThankYou({ firstName, onRestart }) {
  return (
    <section className="thankyou section" style={{ backgroundImage: "url(https://s3.us-east-1.amazonaws.com/cdn.fanduel.com/mlb-sweepstakes/images/thankyou-bg.jpg)" }}>
      <div className="grid-container">
        <div className="grid-x grid-padding-x">
          <div className="small-12 small-offset-0 medium-10 medium-offset-1 large-8 large-offset-2 cell">
            <h2 className="thankyou__h2">Thanks for taking the quiz!</h2>
            <p className="thankyou__p">If you have a FanDuel account, you’re now officially entered for a chance to win a WNBA jersey.</p>
            <p className="thankyou__p">Want to learn more about responsible gaming? Visit <a href="https://www.fanduel.com/rg" target="_blank" rel="noopener noreferrer">FanDuel.com/rg</a> or <a href="https://playsmartfromthestart.org/" target="_blank" rel="noopener noreferrer">PlaySmartFromTheStart.org</a> for tips, tools, and resources.</p>
            <hr/>
            <p className="thankyou__disclaimer"><span>Gambling Problem? Call 1-800-GAMBLER or visit RG-help.com. Call 1-888-789-7777 or visit ccpg.org/chat (CT). Hope is here. GamblingHelpLineMA.org or call (800) 327-5050 for 24/7 support (MA). Visit www.mdgamblinghelp.org (MD). Call 1-877-8HOPE-NY or text HOPENY (467369) (NY).</span><br/>21+ (18+ D.C., KY, & WY) and present in select states (for KS, in affiliation with Kansas Star Casino). No purchase necessary. Limit 1 entry. Restrictions apply. See full terms including methods of entry at sportsbook.fanduel.com.<br/>Major League Baseball trademarks and copyrights are used with permission of Major League Baseball. Visit MLB.com.</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default function App() {
  // current view: "home" | "quiz" | "thankyou"
  const [view, setView] = useState("home");

  // participant data captured on Home
  const [participant, setParticipant] = useState({
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    dob: "",
  });

  // quiz questions
  const questions = useMemo(
    () => [
      {
        id: 1,
        prompt: "Fast Break: What do odds of +200 mean in betting?",
        options: [
          "a. You win $40 for every $20 wagered",
          "b. You need to bet $40 to win $20",
          "c. It's a 50/50 bet",
          "d. The house has no edge",
        ],
        answerIndex: 0,
        correctAnswer: "A",
        explanation: "+200 means you'd win $40 profit on a $20 bet."
      },
      {
        id: 2,
        prompt: "Court Vision: You’ve done your research and feel confident in your picks. What should you watch out for?",
        options: [
          "a. Confirmation bias",
          "b. Illusion of control",
          "c. Risk aversion",
          "d. Tilt",
        ],
        answerIndex: 1,
        correctAnswer: "B",
        explanation: "The illusion of control is when you believe skill or knowledge gives you more influence than you actually have - common in both betting and baseball."
      },
      {
        id: 3,
        prompt: "Shot Clock Strategy: What’s the best way to manage your bankroll, like a team manages minutes?",
        options: [
          "a. Bet more when you're \"hot\"",
          "b. Check your spend and stick to it – easy to do with FanDuel’s My Spend tool!",
          "c. Bet until you get back to even",
          "d. Only bet on your favorite team",
        ],
        answerIndex: 1,
        correctAnswer: "B",
        explanation: "Like a pitch count keeps arms healthy, a budget keeps your play in check."
      },
      {
        id: 4,
        prompt: "Cold Streak Logic: You’ve lost five bets in a row and think a win is “due.” What’s this called?",
        options: [
          "a. Cold streak logic",
          "b. The house edge",
          "c. Gambler’s fallacy",
          "d. Betting rhythm",
        ],
        answerIndex: 2,
        correctAnswer: "C",
        explanation: "The gambler’s fallacy is the mistaken belief that past losses make a win more likely. Each bet is like a new at-bat - independent of the last."
      },
      {
        id: 5,
        prompt: "Defensive Tools: What FanDuel features help you stay in control?",
        options: [
          "a. A hot tip",
          "b. A friend who bets big",
          "c. Time and deposit limits",
          "d. A lucky jersey",
        ],
        answerIndex: 2,
        correctAnswer: "C",
        explanation: "FanDuel offers time, deposit, and wager limits to help you stay in control."
      },
      {
        id: 6,
        prompt: "WNBA History: Who was the first player to dunk in a WNBA game?",
        options: [
          "a. Lisa Leslie",
          "b. Brittney Griner",
          "c. Candace Parker",
          "d. Sylvia Fowles",
        ],
        answerIndex: 2,
        correctAnswer: "A",
        explanation: "Lisa Leslie made history with the first dunk in 2002."
      },
            {
        id: 7,
        prompt: "Make it Rain: Which player led the WNBA in points per game during the 2024 season?",
        options: [
          "a. Caitlin Clark",
          "b. A'ja Wilson",
          "c. Breanna Stewart",
          "d. Arike Ogunbowale",
        ],
        answerIndex: 2,
        correctAnswer: "B",
        explanation: "A'ja Wilson led the league with 26.9ppg"
      },
           {
        id: 8,
        prompt: "Final Shot: What’s a good sign you’re betting responsibly?",
        options: [
          "a. You’re chasing losses",
          "b. You’re betting more than you can afford",
          "c. You’re using RG tools and sticking to a budget",
          "d. You’re betting to make money",
        ],
        answerIndex: 2,
        correctAnswer: "C",
        explanation: "Responsible gaming means staying within your limits and using tools to help you stay in control."
      },
    ],
    []
  );

  const handleStartQuiz = (formValues) => {
    setParticipant(formValues);
    setView("quiz");
  };

  const SHEETS_WEBAPP_URL = "https://script.google.com/macros/s/AKfycbwWXarTL-b_rPNsutJdNX9vTz9J3kG_x8D40Nrhi_72yejzdS8xc7gBS32K3HI5GEPd/exec";

  const handleQuizComplete = async (results) => {
    // results is expected to look like: { total, answers }
    const payload = {
      ...participant, // firstname, lastname, email, phone, dob
      results,        // object: { total, answers }
    };

    try {
      const res = await fetch(SHEETS_WEBAPP_URL, {
        method: "POST",
        headers: { "Content-Type": "text/plain;charset=utf-8" },
        body: JSON.stringify(payload),
      });

      // Optional: basic response handling
      if (!res.ok) {
        const text = await res.text();
        console.error("Sheets error:", res.status, text);
      } else {
        const data = await res.json().catch(() => ({}));
        console.log("Sheets OK:", data);
      }
    } catch (err) {
      console.error("Network error sending to Google Sheets", err);
    } finally {
      // proceed to thank-you view regardless of network success
      setView("thankyou");
    }
  };

  const handleRestart = () => {
    setView("home");
  };

  return (
    <div className="app">
      <main className="main">
        {view === "home" && (
          <Home
            onStartQuiz={handleStartQuiz}
            initialValues={participant}
          />
        )}

        {view === "quiz" && (
          <Quiz
            questions={questions}
            participant={participant}
            onComplete={handleQuizComplete}
            onExit={() => setView("home")}
          />
        )}

        {view === "thankyou" && (
          <ThankYou
            firstName={participant.firstname}
            onRestart={handleRestart}
          />
        )}
      </main>
    </div>
  );
}
